export const tituloPrincipal ="Esqueci minha senha"

export const paragrafoEsqueciSenha = "Digite o e-mail abaixo e enviaremos um link para recuperar sua senha.";

export const Email = 'Endereço de email'

export const btnRecuperarSenha = 'Recuperar Senha'

export const voltarPaginaLogin = 'Voltar para Login'